module.exports = __webpack_public_path__ + "857f64469baa7a8e43695f14cfd1e112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/background-upper.png
// module id = 27
// module chunks = 0